export const notFound = -1;
export const available = 1;
export const purchased = 2;
export const reserved = 3;
